/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { DioxinGraphic } from 'components/DioxinGraphic'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { TEXT_DE, META_DE } from './text_DE'
import { TEXT_FR, META_FR } from './text_FR'
import { SupportedLanguage } from '@ta-interaktiv/types'

const LOCALE: SupportedLanguage = 'de'
const TEXT = LOCALE === 'de' ? TEXT_DE : TEXT_FR
const META = LOCALE === 'de' ? META_DE : META_FR
const ARTICLE_ID = META.articleid

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>{META.title}</h1>
            <h2>{META.lead}</h2>
          </div>
        </div>
      </header>
      <div className='ui vertical segment meta'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>{META.authors}</div>
            <div className='ta updated'>{META.date}</div>
          </div>
        </div>
      </div>
      <div className='ui vertical very fitted segment nopadtop'>
        <DioxinGraphic content={TEXT} />
      </div>
      <div className='ui very fitted  vertical segment footsegment'>
        <div className='ui text container'>
          <div className='footnote'>{META.star}</div>
        </div>
      </div>
      <Footer
        mailTo={LOCALE === 'fr' ? 'interactif@tamedia.ch' : undefined}
        hidePortfolioTeaser
        locale={LOCALE}
        articleId={ARTICLE_ID}
        credits={META.credits as [string, string][]}
      />
    </div>
  )
}
